import React from "react";

import { ThumbnailPlayerProps, ThumbnailPlayerState } from "./models";

import "./style.css";

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

import Box from "@mui/material/Box";
import { ContentType } from "commons/form-constants";

declare let bitmovin: any;

export class ThumbnailPlayer extends React.Component<ThumbnailPlayerProps, ThumbnailPlayerState>
{

	private videoNode: any;
	private player: any;

	constructor(props: Readonly<ThumbnailPlayerProps> | ThumbnailPlayerProps) {

		super(props);

		this.state = {
			loaded: false
		};
	}

	componentDidMount() {

		switch (process.env.REACT_APP_PLAYER_VENDOR) {

			case "BITMOVIN": {

				let playerConfig = {
					"key": process.env.REACT_APP_BITMOVIN_PLAYER_KEY,
					"playback": {
						"muted": true,
						"autoplay": false
					}
				}

				let container = document.getElementById('player');
				let player = new bitmovin.player.Player(container, playerConfig);

				let sourceConfig = {
					"hls": process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content!.vodAdditionalInfos!.vodS3Key!,
					"poster": process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content!.thumbnailData.thumbnailS3Key!
				}

				player.load(sourceConfig).then(function () {
				}).catch(function (reason: any): void {
				});

				break;
			}
			case "VIDEOJS": {

				if (!this.props.content)
					break;

				let videoUrl: string = "";
				let contentType: string = "video/mp4"


				if (this.props.content.type === ContentType.VOD && this.props.content.vodAdditionalInfos !== null) {
					videoUrl = !this.props.content.vodAdditionalInfos.needsEncoding ? (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content.vodAdditionalInfos.vodS3Key!) : (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content.vodAdditionalInfos.encodedContentS3Key!);
					contentType = "video/" + this.props.content.vodAdditionalInfos.format;
				}

				let videoProps = {
					autoplay: process.env.REACT_APP_MAIN_CONTENT_PLAYER_AUTOPLAY === "true" ? true : false,
					controls: process.env.REACT_APP_MAIN_CONTENT_PLAYER_CONTROLS === "true" ? true : false,
					muted: process.env.REACT_APP_MAIN_CONTENT_PLAYER_MUTED === "true" ? true : false,
					loop: process.env.REACT_APP_MAIN_CONTENT_PLAYER_LOOP === "true" ? true : false,
					fluid: true,
					poster: (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL) + this.props.content.thumbnailData.thumbnailS3Key!,
					sources: [{
						src: videoUrl,
						type: contentType
					}]
				}

				this.player = videojs(this.videoNode, videoProps, () => { });
				break;
			}
		}
	}

	render() {
		return (<>
			{process.env.REACT_APP_PLAYER_VENDOR === "BITMOVIN" && <Box className={'bmpui-layout-max-width-1200'}>
				<Box component={"div"} id={'player'} ></Box>
			</Box>}
			{process.env.REACT_APP_PLAYER_VENDOR === "VIDEOJS" && <Box component="div" data-vjs-player>
				<video ref={node => this.videoNode = node} className="video-js vjs-16-9"></video>
			</Box>}
		</>)
	}
}
